// Keep the full audit's weekly context, but attribute findings to the report day.
export function getDailyComplianceAudit(audit, date) {
  const groups = audit.groups
    .map((group) => {
      const violations = group.violations.filter((item) => item.date === date);
      return { ...group, violations, violation_count: violations.length };
    })
    .filter((group) => group.violation_count > 0)
    .sort((a, b) => b.violation_count - a.violation_count);

  return {
    ...audit,
    groups,
    total_violations: groups.reduce((total, group) => total + group.violation_count, 0),
  };
}
